/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useContext, useEffect, useLayoutEffect, useState } from 'react';
import { PageParamsContext } from '../../../../modules/context/PageContext';
import { InternetBarExperienceProps, InternetBarStateTypes } from '../../InternetBar.types';
import { inStayMockResponse } from '../../__mock__/InternetBar.model';
import { INTERNET_BAR_INITIAL_STATE } from '../../utils/constant';

import { InternetBarMarketingExperienceOne } from './InternetBarMarketingExperienceOne';
import { InternetBarMarketingExperienceTwo } from './InternetBarMarketingExperienceTwo';
import { updateDataLayerProperties } from '../../../../modules/utils/common';
import { useSession } from '@marriott/mi-headless-utils';

export const InternetBarMarketingApproachExperience: FC<InternetBarExperienceProps> = (
  pageProps: InternetBarExperienceProps
) => {
  const { preProcessorResponse } = useContext(PageParamsContext);

  const {
    currentStateMapping = {
      ...(pageProps?.isAuthorMode ? inStayMockResponse : (INTERNET_BAR_INITIAL_STATE as InternetBarStateTypes)),
    },
  } = preProcessorResponse || {};
  const { isACDLenabled } = useSession();

  const [viewLoyaltyScreen, setViewLoyaltyScreen] = useState<boolean>(false);

  useEffect(() => {
    if (
      pageProps?.internetPricingData &&
      pageProps?.internetPricingData?.data &&
      pageProps?.internetPricingData?.data?.enrollmentSourceCode
    ) {
      const { userExperience = '', enrollmentSourceCode = '' } = pageProps?.internetPricingData?.data ?? {};
      if (!isACDLenabled) {
        const dataLayer = (window && window?.dataLayer) ?? {};
        updateDataLayerProperties(dataLayer, userExperience, enrollmentSourceCode);
      }
    }
  }, [pageProps?.internetPricingData?.data, isACDLenabled]);

  useLayoutEffect(() => {
    pageProps?.resizeImage && pageProps?.resizeImage();
  });

  return currentStateMapping && pageProps ? (
    <div className="internetbar-marketing-container" data-testid="internet-bar-marketing_container">
      <div className={`internetbar-marketing-content px-3 px-md-3 py-4`}>
        <div className={'col-12 d-flex flex-column justify-content-center px-0 text-center align-items-center'}>
          {viewLoyaltyScreen ? (
            <InternetBarMarketingExperienceTwo {...pageProps} />
          ) : (
            <InternetBarMarketingExperienceOne {...pageProps} setViewLoyaltyScreen={setViewLoyaltyScreen} />
          )}
        </div>
      </div>
    </div>
  ) : null;
};
